<template>
    <prime-dropdown
        v-model="selectedFacilityId"
        :options="dropdownOptions"
        :option-group-label="hasMultipleGroups ? 'name' : undefined"
        :option-group-children="hasMultipleGroups ? 'facilities' : undefined"
        option-label="label"
        option-value="id"
        append-to="self"
        :disabled="disabled"
        :panel-style="{ width: '100%' }"
        :placeholder="t('facility')"
        class="min-w-[250px]"
        :class="{ 'border-red-500 border-2': invalid }"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import PrimeDropdown from 'primevue/dropdown'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
    modelValue: string
    disabled?: boolean
    invalid?: boolean
    facilityGroups: {
        id: string
        name: string
        facilities: {
            id: string
            label: string
        }[]
    }[]
}>()

const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void
}>()

const { t } = useI18n({ useScope: 'global' })
const hasMultipleGroups = computed(() => props.facilityGroups.length > 1)

const dropdownOptions = computed(() => {
    return hasMultipleGroups.value
        ? props.facilityGroups
        : props.facilityGroups.flatMap(group => group.facilities)
})

const selectedFacilityId = computed({
    get: () => props.modelValue,
    set: (value: string | null | undefined) => {
        emit('update:modelValue', value ?? '')
    }
})
</script>
